import {
  STRING,
  METADATA,
  INTEGER,
  NUMBER,
  DATE,
  LOOKUP,
  MEMO,
  COORDINATE,
  GALLERY,
  PROGRAM,
  FILE
} from "../data.types";

const isSimpleType = type =>
  [STRING, METADATA, INTEGER, NUMBER, DATE, LOOKUP].includes(type);

// Нужен, что бы отобразить Input
const isStringType = type => [STRING, METADATA].includes(type);

// Передается как текст, что бы прировнять пустое значение с удаленным
const isTheTextValue = type => [STRING, METADATA, DATE, MEMO].includes(type);

const isComplexType = type =>
  [MEMO, COORDINATE, GALLERY, PROGRAM, FILE].includes(type);

const isNumberType = type => [INTEGER, NUMBER].includes(type);

const isInteger = type => type === INTEGER;

const isMemo = type => type === MEMO;

const isCoordinate = type => type === COORDINATE;

const isGallery = type => type === GALLERY;

const isFile = type => type === FILE;

const isProgram = type => type === PROGRAM;

const isDateType = type => type === DATE;

const isLookUpType = type => type === LOOKUP;

const previewAsHtmlText = type =>
  [STRING, METADATA, INTEGER, NUMBER, DATE, MEMO].includes(type);

const isArrayType = type => [GALLERY, PROGRAM, FILE].includes(type);

export {
  isSimpleType,
  isStringType,
  isTheTextValue,
  isComplexType,
  isNumberType,
  isInteger,
  isDateType,
  isLookUpType,
  isMemo,
  isCoordinate,
  isGallery,
  isFile,
  isProgram,
  previewAsHtmlText,
  isArrayType
};
